'use client'

/**
 * Thin storefront wrapper around SiteHeader that wires the analytics
 * onLinkClick callback. Lives in the storefront (not shared-ui) to keep the
 * dependency direction clean: shared-ui has no analytics import; the
 * storefront glues them — same pattern as AnalyticsPopupHost.
 *
 * Required because the root layout is a server component and `track` is a
 * browser-only, consent-gated client function — the callback can't cross the
 * RSC boundary. All other SiteHeader props (tenant, settings, slots, override)
 * are RSC-serializable and pass straight through.
 */

import { SiteHeader, type SiteHeaderProps } from '@sifly/shared-ui/navigation'
import { track } from '@/lib/analytics'

export function AnalyticsSiteHeader(props: SiteHeaderProps) {
  return (
    <SiteHeader
      {...props}
      onLinkClick={(meta) => track('nav_click', meta)}
    />
  )
}
